import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import vw from 'src/styles/utils';
import media from 'src/styles/media';

const Button = (props) => {
  const { text, handleClick, large, to, isSubmitting } = props;
  return (
    <Root
      as={to ? Link : 'button'}
      className="button white"
      onClick={handleClick}
      large={large}
      {...props}
      isSubmitting={isSubmitting}
    >
      {isSubmitting ? 'Submitting' : text}
    </Root>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  to: PropTypes.string,
  handleClick: PropTypes.func,
  large: PropTypes.bool,
};

const Root = styled.button`
  font-family: Sharp Sans TRIAL;
  font-style: normal;
  font-weight: bold;
  text-transform: uppercase;
  color: #FFFFFF;
  background-color: #DE5647;
  opacity: ${props => props.isSubmitting ? '0.5' : '1'};
  pointer-events: ${props => props.isSubmitting ? 'none' : 'auto'};

  ${vw('font-size', 12)}
  ${vw('line-height', 16)}
  ${vw('letter-spacing', 0.72)}
  ${vw('margin-top', 33)}
  ${vw('padding-top', 12)}
  ${vw('padding-bottom', 12)}
  ${vw('padding-left', 32)}
  ${vw('padding-right', 32)}
`;

export default Button;
